module.exports = __webpack_public_path__ + "static/cloud_giant_smiling_one-348b4287a2a7201fafd7134dd35d48aa.jpeg";